<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="平台类型：" prop="platform_type">
                <span>{{ transEnu(model.platform_type, "platform_type") }}</span>
            </el-form-item>
            <el-form-item label="操作类型：" prop="operation_type">
                <span>{{ transEnu(model.operation_type, "operation_type") }}</span>
            </el-form-item>
            <el-form-item label="操作人：" prop="user_name">
                <span>{{model.user_name}}</span>
            </el-form-item>
            <el-form-item label="操作时间：" prop="add_time">
                <span>{{model.add_time}}</span>
            </el-form-item>
            <el-form-item label="日志描述：" prop="remark">
                <span>{{model.remark}}</span>
            </el-form-item>
            <el-form-item label="IP地址：" prop="ip_address">
                <span>{{model.ip_address}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'systemLogInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                platform_type: '',
                operation_type: '',
                user_name: '',
                add_time: '',
                remark: '',
                ip_address: '',
            },
            getObj:{
                url:'/api/admin/systemlog/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['platform_type', 'operation_type'],
        };
    },
    methods: {}
};
</script>